/**
 * Public enquiry submission for the front-end.
 * Posts to the Node backend's public endpoint so every enquiry lands in the
 * CRM dashboard (leads table), tagged with the originating page.
 */
const API_BASE: string = (import.meta.env.VITE_PUBLIC_API_URL as string) || "/api";

export interface EnquiryPayload {
  full_name: string;
  email?: string;
  phone?: string;
  message?: string;
  investment_type?: string;
  revenue_model?: string;
  page?: string;
  property_id?: number;
}

export interface EnquiryResult {
  ok: boolean;
  message: string;
}

export async function submitEnquiry(payload: EnquiryPayload): Promise<EnquiryResult> {
  let res: Response;
  try {
    res = await fetch(`${API_BASE}/public/enquiry`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
  } catch {
    return { ok: false, message: "Network error. Please check your connection and try again." };
  }

  const responseText = await res.text();
  let parsed: any = null;
  try {
    parsed = responseText ? JSON.parse(responseText) : null;
  } catch {
    parsed = null;
  }

  const serverMsg =
    parsed?.message || parsed?.meta?.message || parsed?.meta?.detail || responseText;

  if (res.ok && parsed?.success) {
    return { ok: true, message: serverMsg || "Enquiry received" };
  }
  return {
    ok: false,
    message:
      serverMsg && typeof serverMsg === "string" && serverMsg.trim()
        ? serverMsg
        : "We couldn't submit your enquiry. Please try again.",
  };
}